<template>
    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-title>
                    <!--<v-icon @click="pushRouteToView('bms')" class="mr-4" style="cursor: pointer">
                        mdi-arrow-left
                    </v-icon>-->
                    <v-btn small @click="pushRouteToView('bms')" class="mr-4 btn-back">
                        <v-icon>
                            mdi-arrow-left
                        </v-icon>
                        Voltar
                    </v-btn>

                    <v-icon left>mdi-hair-dryer-outline</v-icon>
                    Dados do Profissional
                    <v-spacer></v-spacer>
                    <!-- <v-btn
                         outlined
                         color="#6D59E8"
                         class="mr-3"
                         @click="dialogDayOff=true"
                     >
                         <v-icon left>mdi-calendar-plus</v-icon>
                         Tempo de pausa
 
                     </v-btn>-->
                    <v-btn outlined class="btn-del mr-1"
                           v-show="!hasFuture()"
                           @click="dialogDeleteBm=true">
                        <v-icon left>mdi-delete</v-icon>
                        Excluir
                    </v-btn>
                    <v-btn outlined
                           :class="`${bm.active? 'btn-inactive': 'btn-active'} mx-1`"
                           @click="dialogActiveInactive=true"
                           v-show="!bm.assistant" >

                        <span v-if="bm.active"><v-icon left>mdi-diameter-variant</v-icon>Inativar</span><span v-else><v-icon
                        left>mdi-checkbox-marked-circle-outline</v-icon>Ativar</span>
                        <!-- <v-icon left>mdi-pencil</v-icon>
                         <span v-if="bm.active">Inativar</span><span v-else>Ativar</span>
                         -->
                    </v-btn>
                    <v-btn
                        class="btn-edit ml-1"
                        :to="{ name: 'bmEdit', params: { id: bm.id } }"
                    >
                        <v-icon left>mdi-pencil</v-icon>
                        Editar
                    </v-btn>

                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-card style="border-left: solid 10px #3D1159 !important;">
                                <v-card-text class="text-data-visualization">
                                    <v-row>
                                        <v-col cols="12" md="4" sm="12" xs="12" v-show="!bm.assistant">
                                            <v-card tile class="elevation-0">
                                                <input
                                                    v-show="false"
                                                    accept="image/png,image/jpeg"
                                                    ref="inputUpload"
                                                    type="file"
                                                    v-on:change="previewImage"
                                                />

                                                <v-hover v-slot="{ hover }">
                                                    <v-avatar width="100%" height="100%">
                                                        <v-img v-bind:src="bm.image"
                                                               max-height="256"
                                                               max-width="256"
                                                               :aspect-ratio="1"
                                                               @click="$refs.inputUpload.click()"
                                                               style="cursor:pointer;"
                                                        >
                                                            <div
                                                                v-if="hover"
                                                                class="d-flex transition-fast-in-fast-out purple darken-2 v-card--reveal text-h2 white--text"
                                                                style="height: 100%;"
                                                            >
                                                                <v-icon x-large>mdi-image-edit-outline</v-icon>
                                                            </div>
                                                        </v-img>
                                                    </v-avatar>
                                                </v-hover>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="12" md="8" sm="12" xs="12">
                                            
                                            <v-row>
                                                <v-col class="d-flex align-center justify-space-between" xs="12">
                                                    <div class="d-flex align-center flex-gap-2">
                                                        <v-chip
                                                        color="green"
                                                        outlined
                                                        class="mr-2"
                                                        >
                                                        <v-icon left>mdi-check-circle</v-icon>
                                                        Liberado
                                                        {{ bmBalance.balanceReleased | money }}
                                                        </v-chip>
                                                        <v-chip
                                                        color="orange"
                                                        outlined
                                                        class="mr-2"
                                                        >
                                                        <v-icon left>mdi-clock</v-icon>
                                                        À Liberar
                                                        {{ bmBalance.balanceToRelease | money }}
                                                        </v-chip>
                                                    </div>
                                                    <v-btn 
                                                        outlined
                                                        color="#6D59E8"
                                                        :to="{ name: 'bmCashFlow', params: { id: bm.id } }"
                                                    >
                                                        Caixa
                                                        {{ bmBalance.moneyBalance | money }}
                                                        <v-icon right>mdi-arrow-top-right</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col xs="12">
                                                    <b>Apelido:</b>
                                                    <span> {{ bm.nickname }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col md="9" sm="6" xs="12">
                                                    <b>Nome:</b>
                                                    <span> {{ bm.name }}</span>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" md="4" sm="6" xs="12"><b>CPF:</b> {{ bm.cpf }}</v-col>
                                                <v-col cols="12" md="4" sm="6" xs="12"><b>CNPJ:</b> {{ bm.cnpj }}</v-col>
                                                <v-col cols="12" md="4" sm="6" xs="12"><b>Chave Pix:</b> {{ bm.pixkey }}</v-col>
                                            </v-row>
                                            <v-row v-show="!bm.assistant">
                                                <!--                                                <v-col md="7" sm="6" xs="12">-->
                                                <!--                                                    <b>Comissão Sobre Serviço:</b>-->
                                                <!--                                                    {{ bm.commissionService }} %-->
                                                <!--                                                </v-col>-->
                                                <!--                                                -->
                                                <v-col cols="12" md="4" sm="6" xs="12">
                                                    <b>Comissão Sobre Produto:</b>
                                                    {{ bm.commissionProduct }} %
                                                </v-col>

                                                <v-col cols="12" md="4" sm="6" xs="12">
                                                    <b>Comissão Sobre Insumo:</b>
                                                    {{ bm.commissionSupply }} %
                                                </v-col>
                                            </v-row>
                                            <v-row v-show="!bm.assistant">
                                                <v-col md="5" sm="6" xs="12">
                                                    <b>Fator de Tempo:</b> {{ bm.serviceStepTime }} min.
                                                </v-col>
                                            </v-row>
                                            <v-row>

                                                <v-col md="12" sm="12" xs="12">
                                                    <b>Observação:</b> {{ bm.obs }}
                                                </v-col>
                                            </v-row>
                                            <v-row v-show="!bm.assistant">
                                                <v-col md="12" sm="12" xs="12">
                                                    <b>Descrição:</b> {{ bm.desc }}
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col md="12" sm="12" xs="12" v-show="bm.assistant">
                                                    <b>Assistente</b>
                                                </v-col>
                                            </v-row>

                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row v-show="!bm.assistant">
                        <v-col cols="12" sm="12" xs="12">
                            <v-col sm="12" class="text-right pl-0"
                                   style="border-bottom: solid 1px #3D1159 !important; color:#3A33E8;padding-bottom: 5px;">
                                <h2 class="mt-4 pl-0" style="float: left; vertical-align: text-bottom;">Serviços</h2>
                                <v-spacer></v-spacer>
                                <v-btn

                                    outlined
                                    color="#6D59E8"
                                    class="mr-3"
                                    @click="dialogService=true"
                                >
                                    <v-icon left>mdi-chair-rolling</v-icon>
                                    Adicionar Serviço
                                </v-btn>
                            </v-col>
                        </v-col>

                        <v-col
                            cols="12" md="4" sm="12" xs="12"
                            v-for="(service, index) in bm.services"
                            :key="index + '_srvc'"
                        >
                            <v-card class="mx-auto fill-height" tile
                                    style="border-left: solid 10px #3D1159 !important; border-radius: 5px !important; color:#3A33E8;">
                                <v-btn
                                    icon
                                    
                                    absolute
                                    top
                                    right

                                    class="btn-add elevation-0"
                                    style="margin: -5px 0px 0 0;"
                                    @click="editServiceEvent(service)"
                                >
                                    <v-icon dark>
                                        mdi-pencil-circle-outline
                                    </v-icon>
                                </v-btn>

                                <v-btn
                                    icon
                                    
                                    absolute
                                    top
                                    right
                                    v-show="!service.futureSchedule"
                                    class="btn-del elevation-0"
                                    style="margin: -5px 40px 0 0;"
                                    @click="deleteServiceEvent(service)"
                                >
                                    <v-icon dark>
                                        mdi-minus-circle-outline
                                    </v-icon>
                                </v-btn>

                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" xs="12">
                                            <b>Status: </b> <span class="green--text" v-if="service.active"><v-icon
                                            left>mdi-checkbox-marked-circle-outline</v-icon>Ativo</span>
                                            <span class="orange--text" v-else><v-icon left>mdi-diameter-variant</v-icon>Inativo</span>
                                            
                                        </v-col>
                                        <v-col cols="12" xs="12">
                                            <b>Categoria: </b> {{ service.categoryName }}
                                        </v-col>
                                        <v-col cols="12" xs="12">
                                            <b>Nome: </b> {{ service.name }}
                                        </v-col>
                                        <v-col cols="12" xs="12">
                                            <b>Descrição: </b> {{ service.desc }}
                                        </v-col>
                                        <v-col cols="12" xs="12">
                                            <b>Duração: </b> {{ service.duration }} min.
                                        </v-col>
                                        <v-col cols="12" xs="12">
                                            <b>Valor: </b> {{ service.value | money }}
                                        </v-col>
                                        <v-col cols="12" xs="12">
                                            <b>Valor Personalizado: </b> {{ service.customValue | money }}
                                        </v-col>
                                        <v-col cols="12" xs="12">
                                            <b>Comissão: </b> {{ service.commission  }} %
                                        </v-col>
                                    </v-row>

                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row v-show="!bm.assistant">
                        <v-col sm="12">
                            <v-col sm="12" class="text-right pl-0"
                                   style="border-bottom: solid 1px #3D1159 !important; color:#3A33E8;padding-bottom: 5px;">
                                <h2 class="mt-4 pl-0" style="float: left; vertical-align: text-bottom;">
                                    Dias de Trabalho</h2>
                                <v-spacer></v-spacer>
                                <v-btn
                                    outlined
                                    color="#6D59E8"
                                    class="mr-3"
                                    @click="dialogWorkDay=true"
                                >
                                    <v-icon left>mdi-calendar-plus</v-icon>
                                    Adicionar dia de trabalho
                                </v-btn>
                            </v-col>
                        </v-col>

                        <v-col
                            cols="12"
                            md="6"
                            sm="12"
                            xs="12"
                            v-for="weekDay in bm.weekDays"
                            :key="weekDay.id + 'off'"
                        >
                            <v-card class="mx-auto" tile
                                    style="border-left: solid 5px #3D1159 !important; border-radius: 5px !important; color:#3A33E8;">
                                <v-card-text>
                                    <v-row>
                                        <v-col md="9" sm="8" xs="7">
                                            <v-icon left>mdi-calendar-today</v-icon>
                                            {{ weekDay.name }}
                                            das
                                            <b>{{ weekDay.startTime }}</b> hrs. às
                                            <b>{{ weekDay.endTime }}</b> hrs.


                                        </v-col>
                                        <v-col md="3" sm="4" xs="5" class="text-right">
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                icon
                                                class="btn-del mx-1"
                                                @click="deleteWorkDayEvent(weekDay)"
                                            >
                                                <v-icon dark>
                                                    mdi-minus-circle-outline
                                                </v-icon>
                                            </v-btn>

                                            <v-btn
                                                icon
                                                class="btn-add mx-1"
                                                @click="editWorkDayEvent(weekDay)"
                                            >
                                                <v-icon dark>
                                                    mdi-pencil-circle-outline
                                                </v-icon>
                                            </v-btn>

                                        </v-col>
                                    </v-row>
                                </v-card-text>

                            </v-card>
                        </v-col>

                        <v-col sm="12">

                            <v-col sm="12" class="text-right pl-0"
                                   style="border-bottom: solid 1px #3D1159 !important; color:#3A33E8;padding-bottom: 5px;">
                                <h2 class="mt-4 pl-0" style="float: left; vertical-align: text-bottom;">Pausa</h2>
                                <v-spacer></v-spacer>
                                <v-btn

                                    outlined
                                    color="#6D59E8"
                                    class="mr-3"
                                    @click="dialogDayOff=true"
                                >
                                    <v-icon left>mdi-calendar-plus</v-icon>
                                    Criar Pausa
                                </v-btn>
                            </v-col>
                        </v-col>
                        <v-col md="6" sm="12" v-for="(dayOff, index) in bm.dayOffs" :key="dayOff.id">
                            <v-card class="mx-auto" tile
                                    style="border-left: solid 5px #3D1159 !important; border-radius: 5px !important; color:#3A33E8;">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-icon left>mdi-clock-in</v-icon>
                                            Início
                                            {{ dayOff.startDate | formatDate2 }}
                                            hrs.
                                        </v-list-item-title>
                                        <v-list-item-title>
                                            <v-icon left>mdi-clock-out</v-icon>
                                            Fim
                                            {{ dayOff.endDate | formatDate2 }}
                                            hrs.
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                        <v-btn class="btn-del" icon @click="preDeleteDayOff(dayOff.id, index) ">
                                            <v-icon>mdi-minus-circle-outline</v-icon>
                                        </v-btn>
                                    </v-list-item-icon>
                                </v-list-item>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-alert type="warning" outlined v-show="!bm"
                >Nenhum profissional encontrado
                </v-alert>
                <confirm-dialog
                    :dialog="dialogActiveInactive"
                    :title="`${bm.active? 'INATIVAR ': 'ATIVAR '} ${bm.name}`"
                    body="Tem certeza que deseja realizar essa ação?"
                    @dialog-event="inactiveActive">
                </confirm-dialog>
                <confirm-dialog
                    :dialog="dialogDeleteBm"
                    :title="`Excluir  ${bm.name}`"
                    :body="`Tem certeza que deseja excluir o/a profissional ${bm.name} ?`"
                    @dialog-event="deleteBm">
                </confirm-dialog>
                <confirm-dialog
                    :dialog="dialogDeleteBmService"
                    :title="`Excluir  ${bmService.name}`"
                    :body="`Tem certeza que deseja excluir este serviço ${bmService.name} ?`"
                    @dialog-event="deleteBmService">
                </confirm-dialog>
                <confirm-dialog
                    :dialog="dialogDeleteWorkDay"
                    :title="`Excluir Dia de Trabalho `"
                    :body="`Tem certeza que deseja excluir <b>${bmWorkDay.name}</b> das
                                            <b>${bmWorkDay.startTime}</b> hrs. às
                                            <b>${bmWorkDay.endTime}</b> hrs. ?`"
                    @dialog-event="deleteWorkDay">
                </confirm-dialog>
                <confirm-dialog
                    :dialog="dialogDeleteBmDayOff"
                    :title="`Remover Tempo de Pausa`"
                    :body="`Tem certeza que deseja remover este tempo de pausa ?`"
                    @dialog-event="deleteBmDayOff">
                </confirm-dialog>

            </v-card>


            <v-dialog
                v-model="dialogService"
                persistent
                max-width="600px"
            >
                <v-card>
                    <v-form ref="formService"
                            v-model="formIsValid"
                            v-on:submit.prevent="submitService()">
                        <v-card-title>
                            <span class="text-h5"><span v-if="editService">Editar</span><span v-else>Cadastro de</span> Serviço </span>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col xl="12" lg="12" md="12" sm="12">
                                        <v-select
                                            v-model="bmService.id"
                                            :items="servicesSimple"
                                            item-value="id"
                                            label="Serviço"
                                            placeholder="Escolha um Serviço"
                                            :rules="textRules"
                                            outlined
                                            dense
                                            :disabled="editService"
                                        >
                                            <template v-slot:selection="{ item }">
                                                {{ item.categoryName }} - {{ item.name }} - {{ item.value | money }}
                                            </template>
                                            <template v-slot:item="{ item }">
                                                {{ item.categoryName }} - {{ item.name }} - {{ item.value | money }}
                                            </template>
                                        </v-select>
                                    </v-col>

                                    <v-col xl="6" lg="6" md="6" sm="12">
                                        <number-input
                                            label="Duração"
                                            append-icon="mdi-clock-fast"
                                            v-model.number="bmService.duration"
                                            placeholder="Tempo para Executar o Serviço"
                                            :options="optionsMin"
                                            suffix="Minutos"
                                            :rules="[durationRule]"
                                            outlined
                                            dense
                                        ></number-input>
                                    </v-col>
                                    <v-col xl="6" lg="6" md="6" sm="12">
                                        <number-input
                                            label="Valor Personalizado "
                                            v-model.number="bmService.customValue"
                                            placeholder="Valor diferenciado para este profissional"
                                            :options="optionsMoney"
                                            append-icon="mdi-currency-usd"
                                            outlined
                                            dense
                                        ></number-input>
                                    </v-col>
                                    <v-col xl="6" lg="6" md="6" sm="12">
                                        <number-input
                                            label="Comissão"
                                            append-icon="mdi-percent"
                                            v-model.number="bmService.commission"
                                            placeholder="Comissão sobre este serviço"
                                            :options="optionsCommission"
                                            suffix=""
                                            :rules="textRules"
                                            outlined
                                            dense
                                        ></number-input>
                                    </v-col>


                                </v-row>

                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="#FF3816"
                                dark
                                @click="cancelService()"
                            >
                                <v-icon>mdi-close</v-icon>
                                Cancelar
                            </v-btn>
                            <v-btn
                                color="success"
                                type="submit"
                            >
                                <v-icon>mdi-content-save</v-icon>
                                Salvar
                            </v-btn>
                        </v-card-actions>

                    </v-form>
                </v-card>
            </v-dialog>

            <v-dialog
                v-model="dialogWorkDay"
                persistent
                max-width="600px"
            >
                <v-card>
                    <v-form ref="formWorkDay"
                            v-model="formIsValid"
                            v-on:submit.prevent="submitWorkDay()">
                        <v-card-title>
                            <span class="text-h5">Adicionar Dias de Trabalho </span>

                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col xl="6" lg="6" md="6" sm="12" xs="12" cols="12">
                                        <v-select
                                            v-model="bmWorkDay.weekDayID"
                                            :items="weekDays"
                                            item-value="id"
                                            item-text="name"
                                            label="Dia da Semana"
                                            placeholder="Escolha um Dia da Semana"
                                            :rules="textRules"
                                            outlined
                                            dense
                                        ></v-select>
                                    </v-col>

                                    <v-col xl="3" lg="3" md="3" sm="6">
                                        <v-text-field
                                            label="Início"
                                            append-icon="mdi-clock-time-four-outline"
                                            v-model="bmWorkDay.startTime"
                                            placeholder="Horário de Abertura"
                                            v-mask="['##:##']"
                                            :rules="hourRules"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>
                                    <v-col xl="3" lg="3" md="3" sm="6">
                                        <v-text-field
                                            label="Fim"
                                            append-icon="mdi-clock-time-seven-outline"
                                            v-model="bmWorkDay.endTime"
                                            placeholder="Horário de Fechamento"
                                            v-mask="['##:##']"
                                            :rules="hourRules"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>

                                </v-row>

                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="#FF3816"
                                dark
                                @click="cancelWorkDay()"
                            >
                                <v-icon>mdi-close</v-icon>
                                Cancelar
                            </v-btn>
                            <v-btn
                                color="success"
                                type="submit"
                            >
                                <v-icon>mdi-content-save</v-icon>
                                Salvar
                            </v-btn>
                        </v-card-actions>

                    </v-form>
                </v-card>
            </v-dialog>

            <v-dialog
                v-model="dialogDayOff"
                persistent
                max-width="600px"
            >
                <v-card>
                    <v-form ref="formDayOff"
                            v-model="formIsValid"
                            v-on:submit.prevent="submitDayOff()">
                        <v-card-title>
                            <span class="text-h5">Tempo de Pausa </span>

                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-container>

                                <v-row>
                                    <v-col>
                                        <v-text-field
                                            v-model="dayOff.startDate"
                                            outlined
                                            :rules="dateTimeRule"
                                            placeholder="DD/MM/AAAA HH:MM"
                                            v-mask="['##/##/#### ##:##']"
                                            label="Data e Hora de Início"
                                        />
                                    </v-col>
                                    <v-col>
                                        <v-text-field
                                            v-model="dayOff.endDate"
                                            outlined
                                            :rules="dateTimeRule"
                                            placeholder="DD/MM/AAAA HH:MM"
                                            v-mask="['##/##/#### ##:##']"
                                            label="Data e Hora de Término"
                                        />
                                    </v-col>

                                </v-row>

                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="#FF3816"
                                dark
                                @click="dialogDayOff = false"
                            >
                                <v-icon>mdi-close</v-icon>
                                Cancelar
                            </v-btn>
                            <v-btn
                                color="success"
                                type="submit"
                            >
                                <v-icon>mdi-content-save</v-icon>
                                Salvar
                            </v-btn>
                        </v-card-actions>

                    </v-form>
                </v-card>
            </v-dialog>
        </v-col>
    </v-row>
</template>
<style>
.v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%;
}
</style>
<script>
import {mapGetters} from "vuex";
import store from "@/store";
import {mask} from "vue-the-mask";
import ConfirmDialog from '@/components/ConfirmDialog'

import {
    BM_ACTIVE,
    BM_INACTIVE,
    BM_DAYS_OFF_GET,
    BM_DELETE,
    BM_GET,
    BM_ADD_DAY_OFF,
    BM_DELETE_DAY_OFF,
    BM_UPDATE_SERVICE,
    BM_ADD_SERVICE,
    BM_GET_SERVICES,
    BM_UPDATE_WORK_DAY,
    BM_ADD_WORK_DAY, BM_GET_WORK_DAYS, BM_DELETE_WORK_DAY, BM_DELETE_SERVICE,
    BM_BALANCE_GET,

    // BM_EDIT,
    // BM_CREATE,
    // BM_SEARCH,
} from "@/store/actions/bm.type";
import {
    BM_REMOVE_DAY_OFF, BM_RESET_SERVICE,
    BM_RESET_STATE, BM_RESET_WORKDAY,
    SET_BM_ACTIVE,
    SET_BM_IMAGE,
    SET_BM_SERVICE, SET_BM_WORKDAY
} from "@/store/mutations/bm.type";
import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";
import {BMService} from "@/common/api/bm.service";
import {resizeImage} from "@/common/image.service";
import {WEEKDAYS_GET} from "@/store/actions/weekday.type";
import NumberInput from "@/components/NumberInput";
import {SERVICES_SIMPLE_BM_GET} from "@/store/actions/service.type";
import {ADD_SERVICES_SIMPLE, REMOVE_SERVICES_SIMPLE} from "@/store/mutations/service.type";


export default {
    name: "bm",
    directives: {mask},
    props: {
        id: {
            default: 0,
            type: Number,
            required: true,
        },
    },

    components: {NumberInput, ConfirmDialog},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.dispatch(BM_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        Promise.all([
            await store.dispatch(BM_RESET_STATE),
            await store.dispatch(WEEKDAYS_GET),
            await store.dispatch(BM_GET, to.params.id),
            await store.dispatch(SERVICES_SIMPLE_BM_GET, to.params.id),
            await store.dispatch(BM_DAYS_OFF_GET, to.params.id),
            await store.dispatch(BM_BALANCE_GET, to.params.id),
        ]).then(() => {
            next();
        });
    },
    data: () => ({
        //Lista de Usuários
        pagination: {
            sortBy: "name",
        },
        search: "",
        selected: [],

        dayOffID: 0,
        dayOffIndex: 0,

        formIsValid: false,

        dialogActiveInactive: false,
        dialogDeleteBm: false,
        dialogDeleteBmService: false,
        dialogDeleteBmDayOff: false,
        dialogDeleteWorkDay: false,
        dialogDayOff: false,
        dialogWorkDay: false,
        dialogService: false,

        editService: false,
        editWorkDay: false,

        optionsMin: {
            locale: "pt-BR",
            prefix: "",
            length: 9,
            precision: 0,
        },
        optionsMoney: {
            locale: "pt-BR",
            prefix: "R$:",
            length: 9,
            precision: 2,
        },
        optionsCommission: {
            locale: "pt-BR",
            prefix: "",
            length: 4,
            precision: 2,
        },

        numberRules: [
            (v) => {
                if (typeof v !== "undefined" && v !== null) {
                    if (!isNaN(v) && v >= 0.0 && v <= 100) return true;
                }
                return "Informe um valor de 0 a 100";
            },
        ],
        hourRules: [
            (v) => !!v || "Campo obrigatório",
            (value) => {
                if (typeof value !== "undefined" && value !== null) {
                    if (value.length > 0) {
                        const pattern = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;
                        return pattern.test(value) || "Informe um horário válido";
                    }
                }
                return false;
            },
        ],
        textRules: [
            (v) => !!v || "Este campo é obrigatório",
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        dateTimeRule: [
            date => {
                if (!date) return true;
                const pattern = /^([1-9]|([012][0-9])|(3[01]))\/([0]{0,1}[1-9]|1[012])\/\d\d\d\d (20|21|22|23|[0-1]?\d):[0-5]?\d$/
                return pattern.test(date) || "Informe uma data válida."
            }
        ]
    }),
    methods: {
        hasFuture(){
            for (const element of this.bm.services) {
                if(element.futureSchedule){
                    return true
                }
            }
            return false
        },
        pushRouteToView(route) {
            this.$router.push({name: route});
        },

        durationRule(v) {
            if (!v) {
                return "Este campo é obrigatório";
            }
            if (typeof v !== "undefined" && v !== null) {
                if (v % this.bm.serviceStepTime !== 0) {
                    return "Este campo precisa ser múltiplo do fator de serviço";
                }
            }
            return true;
        },

        //Methods Lista Usuarios
        toggleAll() {
            if (this.selected.length) this.selected = [];
            else this.selected = this.dados.slice();
        },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },

        cancelService() {
            if(this.editService){
                this.editService = false
                this.$store.commit(REMOVE_SERVICES_SIMPLE, this.bmService.id);    
            }
            
            this.dialogService = false
            this.$refs.formService.resetValidation();
            this.$store.commit(BM_RESET_SERVICE);
        },
        cancelWorkDay() {
            this.dialogWorkDay = false
            this.$refs.formWorkDay.resetValidation();
            this.$store.commit(BM_RESET_WORKDAY);
        },

        reset() {
            this.$refs.formUsuario.reset();
        },
        async previewImage(img) {
            if (img.target.files[0]) {
                store.commit(CHANGE_PROGRESS, true);

                resizeImage({
                    file: img.target.files[0],
                    maxWidth: 256,
                    maxHeight: 256
                }).then(async (imageFile) => {

                    await BMService.save_image(this.bm.id, imageFile)
                        .then(() => {
                            store.commit(CHANGE_PROGRESS, false);

                            this.snackbar.snackbar = true;
                            this.snackbar.color = "success";
                            this.snackbar.text = "Salvo com sucesso";
                        })
                        .catch(({response}) => {
                            store.commit(CHANGE_PROGRESS, false);

                            this.snackbar.snackbar = true;
                            this.snackbar.color = "error";
                            this.snackbar.text = "Erro ao salvar imagem.";
                            // console.log(response.data);
                            if (typeof response.data.message !== "undefined") {
                                this.snackbar.text =
                                    "Erro ao salvar imagem: " + response.data.message;
                            }
                        });
                    store.commit(SET_BM_IMAGE, URL.createObjectURL(img.target.files[0]));
                }).catch(function (err) {
                    console.log(err)
                    this.$store.commit(CHANGE_PROGRESS, false)

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao Salvar.";

                });
            }

        },
        preDeleteDayOff(id, index) {
            this.dayOffID = id;
            this.dayOffIndex = index;
            this.dialogDeleteBmDayOff = true
        },
        deleteWorkDay(status) {
            console.log(this.bmWorkDay)
            this.dialogDeleteWorkDay = false
            if (!status) {
                return
            }
            this.$store.commit(CHANGE_PROGRESS, true)
            this.$store
                .dispatch(BM_DELETE_WORK_DAY, this.bmWorkDay.id)
                .then(() => {

                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Excluído com sucesso";

                    this.$store.dispatch(BM_GET_WORK_DAYS, this.id)
                    this.$store.commit(BM_RESET_WORKDAY)

                    // this.dayOffID = null
                    // this.dayOffIndex = null
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao excluir.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = response.data.message;
                    }
                });
        },
        deleteBmDayOff(status) {
            this.dialogDeleteBmDayOff = false
            if (!status) {
                return
            }
            this.$store.commit(CHANGE_PROGRESS, true)
            this.$store
                .dispatch(BM_DELETE_DAY_OFF, this.dayOffID)
                .then(() => {

                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Excluído com sucesso";

                    this.$store.commit(BM_REMOVE_DAY_OFF, this.dayOffIndex)
                    this.dayOffID = null
                    this.dayOffIndex = null
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao excluir.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = response.data.message;
                    }
                });
        },
        deleteBm(status) {
            this.dialogDeleteBm = false
            if (!status) {
                return
            }
            this.$store.commit(CHANGE_PROGRESS, true)
            this.$store
                .dispatch(BM_DELETE)
                .then(() => {

                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Excluído com sucesso";

                    this.$router.push({
                        name: "bms",
                    });
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao excluir.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = response.data.message;
                    }
                });
        },
        deleteBmService(status) {
            this.dialogDeleteBmService = false
            if (!status) {
                return
            }
            this.$store.commit(CHANGE_PROGRESS, true)
            this.$store
                .dispatch(BM_DELETE_SERVICE)
                .then(async () => {

                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Excluído com sucesso";

                    await store.dispatch(BM_GET_SERVICES, this.id)
                    await store.dispatch(SERVICES_SIMPLE_BM_GET, this.id)
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao excluir.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = response.data.message;
                    }
                });
        },
        inactiveActive(status) {
            this.dialogActiveInactive = false
            if (!status) {
                return
            }
            let action = this.bm.active ? BM_INACTIVE : BM_ACTIVE;
            this.$store.commit(CHANGE_PROGRESS, true)

            this.$store
                .dispatch(action, this.bm.id)
                .then(() => {

                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Alterado com sucesso";
                    this.$store.commit(SET_BM_ACTIVE, !this.bm.active)
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao alterar.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = response.data.message;
                    }
                });
        },
        editServiceEvent(service) {
            this.$store.commit(SET_BM_SERVICE, service)
            this.$store.commit(ADD_SERVICES_SIMPLE, service)
            this.editService = true
            this.dialogService = true
        },
        editWorkDayEvent(workDay) {
            this.$store.commit(SET_BM_WORKDAY, workDay)
            this.editWorkDay = true
            this.dialogWorkDay = true
        },
        deleteWorkDayEvent(workDay) {
            this.$store.commit(SET_BM_WORKDAY, workDay)
            this.dialogDeleteWorkDay = true
        },
        deleteServiceEvent(service){
            this.$store.commit(SET_BM_SERVICE, service)
            this.dialogDeleteBmService = true
        },


        submitService() {
            if (this.$refs.formService.validate()) {
                let action = this.editService ? BM_UPDATE_SERVICE : BM_ADD_SERVICE;
                this.$store.commit(CHANGE_PROGRESS, true)

                this.$store
                    .dispatch(action)
                    .then(async () => {
                        this.dialogService = false
                        this.$store.commit(CHANGE_PROGRESS, false)
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Processado com sucesso";
                        this.$refs.formService.resetValidation();
                        this.$store.commit(BM_RESET_SERVICE);
                        this.editService = false;
                        await store.dispatch(BM_GET_SERVICES, this.id)
                        await store.dispatch(SERVICES_SIMPLE_BM_GET, this.id)

                    })
                    .catch(({response}) => {
                        this.$store.commit(CHANGE_PROGRESS, false)
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao Processar.";
                        // console.log(response.data);
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text = response.data.message;
                        }
                    });
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        },

        submitWorkDay() {
            if (this.$refs.formWorkDay.validate()) {
                let action = this.editWorkDay ? BM_UPDATE_WORK_DAY : BM_ADD_WORK_DAY;
                this.$store.commit(CHANGE_PROGRESS, true)

                this.$store
                    .dispatch(action)
                    .then(async () => {
                        this.dialogWorkDay = false
                        this.$store.commit(CHANGE_PROGRESS, false)
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Processado com sucesso";
                        this.$refs.formWorkDay.resetValidation();
                        this.$store.commit(BM_RESET_WORKDAY);
                        this.editWorkDay = false;
                        await store.dispatch(BM_GET_WORK_DAYS, this.id)

                    })
                    .catch(({response}) => {
                        this.$store.commit(CHANGE_PROGRESS, false)
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao Processar.";
                        // console.log(response.data);
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text = response.data.message;
                        }
                    });
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        },

        submitDayOff() {

            if (this.$refs.formDayOff.validate()) {

                this.$store.commit(CHANGE_PROGRESS, true)

                this.$store
                    .dispatch(BM_ADD_DAY_OFF)
                    .then(async () => {
                        this.dialogDayOff = false
                        this.$store.commit(CHANGE_PROGRESS, false)
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Adicionado com sucesso";
                        this.$refs.formDayOff.resetValidation();
                        await store.dispatch(BM_DAYS_OFF_GET, this.id)

                    })
                    .catch(({response}) => {
                        this.$store.commit(CHANGE_PROGRESS, false)
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao Adicionar.";
                        // console.log(response.data);
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text = response.data.message;
                        }
                    });
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        }

    },
    mounted() {
    },
    computed: {
        // ...mapState({
        //   courses: state => state.
        // })

        ...mapGetters(["checkUsers", "bm", "snackbar", "servicesSimple", "weekDays", "bmWorkDay", "dayOff", "bmService", "bmBalance"]),
    },
    watch: {},
};
</script>
